import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'
import routes from './routers'


//路由模式
const router = createRouter({
    history: createWebHashHistory(),
    routes: routes
})

//登录验证
router.beforeEach(function (to, from, next) {
    const is_login = store.getters["user/isLogin"]
    // 判断当前url是否要求验证
    if (to.matched.some(r => r.meta.requiresAuth)) {
        // 判断用户是否登陆
        if (!is_login) {
            localStorage.setItem("preRoute", JSON.stringify({name:to.name, path:to.path}))
            // 跳转到登录界面
            next('/sso')
        }
        else {
            // 保留在当前url
            next()
        }
    } else {
        next()
    }
})



export default router






